const currency = process.env.CURRENCY

export default currency
